<template>
    <div>
        <p><a class="button is-danger reset-button" @click="resetAllData">Reset All</a></p>
        <div class="tabs is-boxed">
            <ul>
                <li v-for="tab in tabs" :key="tab.name" :class="{ 'is-active': activeTab == tab.name }">
                    <a @click="changeTab(tab.name)">{{ tab.displayName }}</a>
                </li>                
            </ul>
        </div>
        <div>
            <basic-tab v-if="activeTab == 'basic-tab'" />
            <attack-tab v-if="activeTab == 'attack-tab'" />
            <monk-tab v-if="activeTab == 'monk-tab'" />
            <psion-tab v-if="activeTab == 'psion-tab'" />
            <custom-tab v-if="activeTab == 'custom-tab'" />
        </div>
    </div>    
</template>

<script>
import BasicTab from './form-tabs/BasicTab.vue';
import AttackTab from './form-tabs/AttackTab.vue';
import MonkTab from './form-tabs/MonkTab.vue';
import PsionTab from './form-tabs/PsionTab.vue';
import CustomTab from './form-tabs/CustomTab.vue';

const tabs = [
    {
        name: 'basic-tab',
        displayName: 'Basic Info',
    },
    {
        name: 'attack-tab',
        displayName: 'Attack Info',
    },
    {
        name: 'monk-tab',
        displayName: 'Monk',
    },
    {
        name: 'psion-tab',
        displayName: 'Psion',
    },
    {
        name: 'custom-tab',
        displayName: 'Custom',
    },
];

export default {      
    components: {
        'basic-tab': BasicTab,
        'attack-tab': AttackTab,
        'monk-tab': MonkTab,
        'psion-tab': PsionTab,
        'custom-tab': CustomTab,
    },
    data: function() {
        return {
            activeTab: 'basic-tab',
            tabs: tabs,
        };
    },
    computed: {

    },
    methods: {           
        changeTab(tabName) {
            this.activeTab = tabName;
        },
        resetAllData() {
            this.$store.commit('basic/resetState');
            this.$store.commit('attack/resetState');
            this.$store.commit('damage/resetState');
            this.$store.commit('custom/resetState');
            this.$store.commit('monk/resetState');
            this.$store.commit('psion/resetState');
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .field-container {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1rem;
    }

    .field {
        width: calc(50% - 2rem);
        margin: 0 1rem 1rem;
    }

    .field.full {
        width: calc(100% - 2rem);        
    }

    .field.third {
        width: calc(33% - 2rem);
    }

    .field.quarter {
        width: calc(25% - 2rem);
    }

    hr {
        width: 100%;
        background-color: #ccc;
    }

    .reset-button {
        margin-bottom: 1rem;
    }
</style>
